export const HEADER_LABEL_URL_MAP = {
  ROOT: {
    label: 'Home',
    test: (url: string) => url === '/',
  },
  GIFT_CARDS: { label: 'Gift Cards Admin Dashboard', test: (url: string) => url.startsWith('/gift-cards') },
};
